import { i18n } from 'app/utils/i18n';
import { VariableGroup, getSchemaByGroup, groupLabels } from '../variable-schema';
import { VariableField } from './VariableField';
import { parseStoredValue } from '../utils/parse-stored-value';
import './VariableGroupPanel.scss';

interface VariableGroupPanelProps {
  group: VariableGroup;
  variables: Record<string, unknown>;
  onChange: (key: string, value: string) => void;
  onHover?: (group: VariableGroup | null) => void;
  onFieldHover?: (key: string | null) => void;
}

export function VariableGroupPanel({ group, variables, onChange, onHover, onFieldHover }: VariableGroupPanelProps) {
  const defs = getSchemaByGroup(group);
  const label = i18n(groupLabels[group]);

  const hasFontField = defs.some((def) => def.type === 'font');

  const renderField = (def: (typeof defs)[number]) => (
    <VariableField
      key={def.key}
      def={def}
      value={parseStoredValue(variables[def.key], def)}
      onChange={onChange}
      onFieldHover={onFieldHover}
      variables={variables}
    />
  );

  // Groups with font pickers get a second row: metrics on top, appearance below.
  const isAppearance = (def: (typeof defs)[number]) => def.type === 'font' || def.type === 'color';
  const metricDefs = hasFontField ? defs.filter((def) => !isAppearance(def)) : defs;
  const appearanceDefs = hasFontField ? defs.filter(isAppearance) : [];

  return (
    <div className="variable-group-panel mb-3" onMouseEnter={() => onHover?.(group)} onMouseLeave={() => onHover?.(null)}>
      <h6 className="variable-group-panel__title mb-2">{label}</h6>
      <div className="d-flex gap-3 align-items-end flex-wrap">{metricDefs.map(renderField)}</div>
      {appearanceDefs.length > 0 && <div className="d-flex gap-3 align-items-end flex-nowrap mt-2">{appearanceDefs.map(renderField)}</div>}
    </div>
  );
}
